const React = require('react');
const { wrapFunctionalComponent } = require('utils/framework').default;
const getBaseComponent = require('utils/framework/getBaseComponent').default;
const getStyledComponent = require('utils/framework/getStyledComponent').default;
const {
    compose, border, color, flexbox, layout, typography, shadow, space
} = require('styled-system');
const grid = require('style/grid').default;
const theme = require('style/theme').default;
const uiUtils = require('utils/UI').default;

const StyledComponent = getStyledComponent({
    InnerComp: getBaseComponent({
        elementType: 'div',
        isBasicElement: false,
        useRef: true
    }),
    styledProps: [props => [props.baseCss, compose(border, color, flexbox, grid, layout, typography, shadow, space), props.css]]
});

const px = n => (typeof n === 'number' ? n + 'px' : n);

const widthToColumns = (width, repeat) =>
    Array.isArray(width) ? width.map(w => widthToColumns(w, repeat)) : !!width && `repeat(auto-${repeat}, minmax(${px(width)}, 1fr))`;

const countToColumns = n => (Array.isArray(n) ? n.map(countToColumns) : !!n && (typeof n === 'number' ? `repeat(${n}, 1fr)` : n));

const Grid = React.forwardRef(({ width, columns, repeat, ...props }, ref) => {
    const gridTemplateColumns = width ? widthToColumns(width, repeat) : countToColumns(columns);

    return (
        <StyledComponent
            __ref={ref}
            gridTemplateColumns={gridTemplateColumns}
            {...props}
            {...uiUtils.getAriaButtonProps('div', props)}
        />
    );
});

Grid.defaultProps = {
    theme,
    display: 'grid',
    gap: 3,
    repeat: 'fit'
};

module.exports = wrapFunctionalComponent(Grid, 'Grid');
